import { createSelector } from '@ngrx/store'

import { ModalState } from './modal.reducer'

export const selectedModal = (state): ModalState => state.modalContainer

export const modal = createSelector(selectedModal, modals => modals.modal)
export const modalVisibility = createSelector(selectedModal, modals => modals.visibility)
